/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE';
export const NEWSLETTER_UNSUBSCRIBE = 'NEWSLETTER_UNSUBSCRIBE';
export const NEWSLETTER_CONFIRM_SUBSCRIPTION =
  'NEWSLETTER_CONFIRM_SUBSCRIPTION';
export const NEWSLETTER_MESSAGE_SEND = 'NEWSLETTER_MESSAGE_SEND';
export const NEWSLETTER_MESSAGE_SEND_RESET = 'NEWSLETTER_MESSAGE_SEND_RESET';
export const NEWSLETTER_MESSAGE_SEND_TOGGLE_MODAL =
  'NEWSLETTER_MESSAGE_SEND_TOGGLE_MODAL';
export const NEWSLETTER_MESSAGE_TEST_SEND = 'NEWSLETTER_MESSAGE_TEST_SEND';
export const NEWSLETTER_MESSAGE_TEST_SEND_RESET =
  'NEWSLETTER_MESSAGE_TEST_SEND_RESET';
export const NEWSLETTER_MESSAGE_TEST_SEND_TOGGLE_MODAL =
  'NEWSLETTER_MESSAGE_TEST_SEND_TOGGLE_MODAL';
export const NEWSLETTER_MESSAGE_SEND_GET_TOKEN =
  'NEWSLETTER_MESSAGE_SEND_GET_TOKEN';

// send history
export const SUBMIT_SEND_HISTORY_ACTION = 'SUBMIT_SEND_HISTORY_ACTION';
export const RESET_SUBMIT_SEND_HISTORY_ACTION =
  'RESET_SUBMIT_SEND_HISTORY_ACTION';
export const RESET_DELETE_SEND_HISTORY =
  'RESET_DELETE_SEND_HISTORY_SEND_HISTORY';
export const GET_SEND_HISTORY = 'GET_SEND_HISTORY';
export const DELETE_SEND_HISTORY = 'DELETE_SEND_HISTORY';

// subscriptions
export const SUBMIT_SUBSCRIPTIONS_ACTION = 'SUBMIT_SUBSCRIPTIONS_ACTION';
export const RESET_SUBMIT_SUBSCRIPTIONS_ACTION =
  'RESET_SUBMIT_SUBSCRIPTIONS_ACTION';
export const RESET_DELETE_SUBSCRIPTIONS =
  'RESET_DELETE_SUBSCRIPTIONS_SUBSCRIPTIONS';
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const DELETE_SUBSCRIPTIONS = 'DELETE_SUBSCRIPTIONS';
export const NEWSLETTER_ADD_SUBSCRIPTION = 'NEWSLETTER_ADD_SUBSCRIPTION';
export const NEWSLETTER_EXPORT_SUBSCRIPTIONS =
  'NEWSLETTER_EXPORT_SUBSCRIPTIONS';
export const NEWSLETTER_IMPORT_SUBSCRIPTIONS =
  'NEWSLETTER_IMPORT_SUBSCRIPTIONS';
